export default function CTASection() {
  return (
    <section className="w-full py-16 md:py-20 px-4 md:px-6 lg:px-10 bg-background-100">
      <div className="max-w-2xl mx-auto text-center">
        <h2 className="font-heading text-3xl md:text-4xl font-extrabold text-foreground-950 mb-4 leading-tight">
          Ready to Find Better Products Faster?
        </h2>
        <p className="text-base md:text-lg text-foreground-600 mb-8 leading-relaxed">
          Access the complete Kakobuy Spreadsheet database and start discovering curated products organized across 14 categories right now.
        </p>
        <a
          href="https://kaspreadsheet.com"
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
        >
          Access Kakobuy Spreadsheet
          <i className="ri-arrow-right-up-line"></i>
        </a>
      </div>

      {/* Product image strip */}
      <div className="mt-14 w-full overflow-hidden">
        <div className="flex gap-4 justify-center flex-wrap">
          <div className="w-28 h-28 md:w-32 md:h-32 rounded-2xl overflow-hidden bg-background-50">
            <img
              src="https://readdy.ai/api/search-image?query=Clean%20white%20sneaker%20on%20cream%20background%2C%20minimalist%20product%20photography%2C%20natural%20light%2C%20isolated%20style%2C%20simple%20clean%20aesthetic&width=200&height=200&seq=strip-shoe-01&orientation=squarish"
              alt="Kakobuy Spreadsheet shoe find"
              title="Kakobuy Spreadsheet Sneakers"
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>
          <div className="w-28 h-28 md:w-32 md:h-32 rounded-2xl overflow-hidden bg-background-50">
            <img
              src="https://readdy.ai/api/search-image?query=Stylish%20baseball%20cap%20on%20cream%20background%2C%20minimalist%20product%20photography%2C%20natural%20light%2C%20isolated%20style%2C%20simple%20clean%20aesthetic&width=200&height=200&seq=strip-cap-02&orientation=squarish"
              alt="Kakobuy Spreadsheet cap product"
              title="Kakobuy Spreadsheet Headwear"
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>
          <div className="w-28 h-28 md:w-32 md:h-32 rounded-2xl overflow-hidden bg-background-50">
            <img
              src="https://readdy.ai/api/search-image?query=Elegant%20leather%20handbag%20on%20cream%20background%2C%20minimalist%20product%20photography%2C%20natural%20light%2C%20isolated%20style%2C%20simple%20clean%20aesthetic&width=200&height=200&seq=strip-bag-03&orientation=squarish"
              alt="Kakobuy Spreadsheet bag find"
              title="Kakobuy Spreadsheet Bags"
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>
          <div className="w-28 h-28 md:w-32 md:h-32 rounded-2xl overflow-hidden bg-background-50">
            <img
              src="https://readdy.ai/api/search-image?query=Cozy%20hoodie%20folded%20on%20cream%20background%2C%20minimalist%20product%20photography%2C%20natural%20light%2C%20isolated%20style%2C%20simple%20clean%20aesthetic&width=200&height=200&seq=strip-hoodie-04&orientation=squarish"
              alt="Kakobuy Spreadsheet hoodie find"
              title="Kakobuy Spreadsheet Hoodies"
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>
          <div className="w-28 h-28 md:w-32 md:h-32 rounded-2xl overflow-hidden bg-background-50 hidden lg:block">
            <img
              src="https://readdy.ai/api/search-image?query=Elegant%20wristwatch%20on%20cream%20background%2C%20minimalist%20product%20photography%2C%20natural%20light%2C%20isolated%20style%2C%20simple%20clean%20aesthetic&width=200&height=200&seq=strip-watch-05&orientation=squarish"
              alt="Kakobuy Spreadsheet accessory find"
              title="Kakobuy Spreadsheet Accessories"
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
}